import { Component, OnInit } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { CustomerService } from "src/app/core/services/customer.service";
import { CustomerSubscriptionItem } from "src/app/shared/models/CustomerSubscription.item";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";

@Component({
	selector: "app-about-me-subscriptions",
	templateUrl: "./about-me-subscriptions.component.html",
	styleUrls: ["../../../customer.scss"],
})
export class AboutMeSubscriptionsComponent implements OnInit {
	constructor(public app: AppService, public customerService: CustomerService) {}

	ngOnInit(): void {
		this.customerService.publicCustomer.subscribe((customer) => {
			customer.subscriptions?.forEach((subscription) => {
				subscription.frequencyDisplayName = this.customerService.venueService.subscriptionFrequencyToFrequencyDisplayName(subscription.frequency);
				subscription.price = subscription.quantity
					? this.customerService.venueService.menuItemGetPriceFromNumber(subscription.ooMenuItem, subscription.priceNumber) * subscription.quantity
					: this.customerService.venueService.menuItemGetPriceFromNumber(subscription.ooMenuItem, subscription.priceNumber);
			});
		});
	}

	onStopSubscription(rec: CustomerSubscriptionItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to cancel your ${rec.ooMenuItem.name} subscription from ${rec.venueName}?`,
			accept: async () => {
				rec.inactive = true;
				this.customerService.subscriptionSave(rec);
				this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Subscription cancelled successfully.` });
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
